import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const OneDriveOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M9.818 0C8.336 0 7.051.781 6.333 1.94c-.432-.207-.91-.333-1.424-.333-1.807 0-3.273 1.44-3.273 3.214 0 .29.052.565.125.832C.768 5.791 0 6.62 0 7.633c0 1.11.916 2.01 2.045 2.01h.451c-.015-.134-.041-.265-.041-.402 0-1.656 1.14-3.056 2.689-3.483.635-1.94 2.49-3.347 4.674-3.347 1.082 0 2.103.342 2.94.967.345-.1.704-.15 1.068-.157C13.45 1.384 11.799 0 9.818 0zm0 4.018c-1.807 0-3.273 1.44-3.273 3.214 0 .015.005.027.005.04-.133-.026-.272-.04-.414-.04-1.13 0-2.045.9-2.045 2.01 0 1.109.915 2.008 2.045 2.008h10.228c.904 0 1.636-.72 1.636-1.607 0-.888-.732-1.607-1.636-1.607-.054 0-.103.01-.155.015.095-.256.155-.53.155-.819 0-1.331-1.1-2.41-2.455-2.41-.556 0-1.065.188-1.476.495-.597-.784-1.541-1.3-2.615-1.3z"
            transform="translate(-158 -519) translate(126 23) translate(32 220) translate(0 276) translate(3 6)"
          />
        </g>
      </g>
    </svg>
  );
};

export default OneDriveOutline;
